import React, { useEffect, useState, useCallback } from "react";
import Select from "react-select";
import axios from "axios";
import BlockUi from "react-block-ui";
import { customSelectStyle } from "../../../../_metronic/_partials/dropdowns/ReactSelectCustomStyle";
import { PLAN_TYPES } from "./constants";
import { Switch } from "@material-ui/core";

export default function Step1(props) {
  const [featureLimits, setFeatureLimits] = useState(
    props.formik.values.limits
  );
  const [isLoading, setIsLoading] = useState(true);
  const [universalCredits, setUniversalCredits] = useState(0);

  const { values, errors, touched, handleChange, setFieldValue } = props.formik;
  const loadFeatures = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/features/?universal=${values.is_universal}`,
      {
        params: { plan_type: values.plan_type }
      }
    );

    let allFeatures = response.data.data;
    setUniversalCredits(response.data.universalCreditValue || 0);
    const featureLimitsMap = {};
    if (props.id) {
      props.formik.values.limits.forEach(limit => {
        featureLimitsMap[limit.feature_id] = {
          limit: limit.limit,
          trial_limit: limit.trial_limit
        };
      });
    }
    const featuresWithLimits = allFeatures.map(feature => {
      const limits = featureLimitsMap[feature.id] || {
        limit: 0,
        trial_limit: 0
      };


      const isUniversalFeature = feature.name === "universal_credits";
      const isUniversalMode = values?.is_universal;
      const hasNoIdParams = !props.id;

      const featureIsUniversalWithoutIdParams = isUniversalFeature && isUniversalMode && hasNoIdParams;

      return {
        feature_id: feature.id,
        feature_name: feature.description,
        limit:
            featureIsUniversalWithoutIdParams ? universalCredits : limits.limit,
        trial_limit: limits.trial_limit
      };
    });

    setFeatureLimits(featuresWithLimits);
    setFieldValue("limits", featuresWithLimits);
    setIsLoading(false);
  };

  const handleSwitchChange = useCallback(
    event => {
      const isChecked = event.target.checked;

      props.formik.setFieldValue("is_universal", isChecked);
    },
    [props.formik]
  );

  useEffect(() => {
    loadFeatures();
  }, []);

  useEffect(() => {
    loadFeatures();
  }, [values.is_universal, values.plan_type, universalCredits]);

  const RenderFeatures = useCallback(
    ({ limits }) => (
      <div className="container mb-20">
        <div className="row mb-2">
          <div className="col-md-6" />
          <div className="col-md-2">
            <div className="form-label text-center">Trial*</div>
          </div>
          <div className="col-md-2">
            <div className="form-label text-center">Limite*</div>
          </div>
        </div>
        {!isLoading &&
          limits.map((feature, index) => (
            <div
              key={feature.feature_id}
              className="row mb-3 align-items-center"
            >
              <div className="col-md-6">
                <div className="form-label">{feature.feature_name}</div>
              </div>
              <div className="col-md-2">
                <input
                  type="number"
                  placeholder="Trial Limit"
                  name={`limits[${index}].trial_limit`}
                  value={feature.trial_limit}
                  onChange={handleChange}
                  className={
                    "form-control " +
                    (errors.name && touched.name ? "is-invalid" : "")
                  }
                />
              </div>
              <div className="col-md-2">
                <input
                  type="number"
                  placeholder="Limit"
                  name={`limits[${index}].limit`}
                  value={feature.limit}
                  onChange={handleChange}
                  className={
                    "form-control " +
                    (errors.name && touched.name ? "is-invalid" : "")
                  }
                />
              </div>
            </div>
          ))}
      </div>
    ),
    [handleChange, errors, touched, isLoading]
  );

  return (
    <BlockUi tag="div" blocking={props.formik.isSubmitting}>
      <div className="row no-gutters mb-20">
        {/*<pre>
                {JSON.stringify(props.formik.values, null, '\t')}
                </pre>*/}
        <div className="col-xl-12">
          <div
            className="border-radius-only-left"
            style={{ backgroundColor: "#fff", padding: "40px", height: "100%" }}
          >
            <div className="row mb-5">
              <div className="col-xl-6">
                <label className="form-label">
                  Nome <span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  className={
                    "form-control " +
                    (props.formik.errors.name && props.formik.touched.name
                      ? "is-invalid"
                      : "")
                  }
                  value={props.formik.values.name}
                  onChange={props.formik.handleChange}
                />
                {props.formik.errors.name && props.formik.touched.name && (
                  <label className="invalid-feedback">
                    {props.formik.errors.name}
                  </label>
                )}
              </div>
              <div className="col-xl-6">
                <label className="form-label">
                  Tipo de planos <span class="text-danger">&nbsp;*</span>
                </label>
                <Select
                  name="plan_type"
                  options={PLAN_TYPES}
                  className={
                    props.formik.errors.plan_type &&
                    props.formik.touched.plan_type
                      ? "is-invalid"
                      : ""
                  }
                  onChange={option =>
                    props.formik.setFieldValue("plan_type", option.value)
                  }
                  value={PLAN_TYPES.find(
                    option => option.value === props.formik.values.plan_type
                  )}
                  placeholder="Selecione.."
                  getOptionLabel={option => option.label}
                  getOptionValue={option => option.value}
                  noOptionsMessage={() => <span>Sem resultados.</span>}
                  theme={customSelectStyle}
                />
              </div>
              <div className="col-xl-6 mt-5">
                <label className="subheader-text">Plano universal</label>
                <Switch
                  color="primary"
                  checked={Boolean(values.is_universal)}
                  name="is_universal"
                  onChange={handleSwitchChange}
                />
              </div>

              <div className="col-xl-12 mt-5">
                <p className="subheader-text  mt-10 mb-10">
                  Produtos(Features)
                </p>
              </div>
              <RenderFeatures limits={values.limits} />
            </div>
            <div className="row mb-5">
              <div className="col-xl-12">
                <button
                  type="button"
                  onClick={props.formik.handleSubmit}
                  className="btn btn-primary"
                  style={{ width: "100%", height: "50px" }}
                >
                  SALVAR GRUPO DE PLANOS
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BlockUi>
  );
}
